import { render, staticRenderFns } from "./OrgXmlReport.vue?vue&type=template&id=794efbc2&"
import script from "./OrgXmlReport.vue?vue&type=script&lang=js&"
export * from "./OrgXmlReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports